import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

// Pages where floating buttons should be hidden
const ADMIN_PAGES = ['/super-admin', '/admin', '/business', '/dashboard'];

const FloatingTransferButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 500);
    return () => clearTimeout(timer);
  }, []);

  // Hide on admin pages
  const isAdminPage = ADMIN_PAGES.some(path => location.pathname.startsWith(path));
  if (isAdminPage) {
    return null;
  }

  const handleClick = () => {
    navigate('/auth');
  };

  return (
    <button
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={`
        fixed z-50
        transition-all duration-500 ease-out
        hidden lg:block lg:right-0 lg:bottom-auto lg:top-[calc(50%+13px)]
        ${isVisible ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'}
      `}
      style={{ right: '0px' }}
      aria-label="Débuter un transfert"
      data-testid="floating-transfer-btn"
    >
      {/* Desktop version - vertical (hidden on mobile and tablet) */}
      <div
        className={`
          flex items-center gap-2 
          px-2 py-4
          h-[130px]
          bg-[#67ffbb] hover:bg-[#4de6a8]
          text-gray-900 font-semibold text-xs lg:text-sm
          rounded-l-xl
          shadow-lg hover:shadow-xl
          transition-all duration-300
        `}
        style={{
          writingMode: 'vertical-rl',
          textOrientation: 'mixed',
        }}
      >
        <span className="relative flex h-2.5 w-2.5">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-gray-900 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-gray-900"></span>
        </span>
        <span className="tracking-wide">Transfert</span>
        <ArrowRight className={`w-4 h-4 rotate-90 transition-transform duration-300 ${isHovered ? 'translate-y-1' : ''}`} />
      </div>
    </button>
  );
};

export default FloatingTransferButton;
